import TranslatedText from './TranslatedText';

export default function ProgressTodayTooltip() {
  return (
    <div className="relative h-[14px] w-0.5 bg-blue-600">
      <div
        className={`absolute right-1/2 top-[-10px] flex h-5 -translate-y-1/2 translate-x-1/2 items-center rounded-[3px] bg-blue-600 px-[6px] py-[2px] text-xs font-semibold leading-4 text-white`}
      >
        <TranslatedText text="Common.today" />
      </div>

      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="2"
        height="2"
        viewBox="0 0 2 2"
        fill="none"
        className="absolute bottom-4 left-[47%] top-[1px] -translate-y-1/2 translate-x-1/2"
      >
        <path
          d="M2 0C0.895431 3.22128e-08 0 0.895431 0 2V0H2Z"
          fill="#155DFC"
        />
      </svg>

      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="2"
        height="2"
        viewBox="0 0 2 2"
        fill="none"
        className="absolute bottom-4 right-[47%] top-[1px] -translate-x-1/2 -translate-y-1/2"
      >
        <path d="M0 0C1.10457 3.22128e-08 2 0.895431 2 2V0H0Z" fill="#155DFC" />
      </svg>
    </div>
  );
}
